import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Heading extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return modelName.replace(/^school-options\/heading/, 'optionHeading');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace(/^optionHeading/, 'school-options/heading'),
    );
  }

  normalize(model, hash, prop) {
    let defaults = {
      sequence: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
